<template>
  <v-container fluid>
    <v-row dense no-gutters class="py-3">
      <v-col v-for="(action,index) in actionsEisy" :key="index" class="px-2" cols="3" :class="action.hidden">
        <v-card tile @click="sendInventarios(action.action)">
          <v-img src="@/assets/images/indicador.jpg"
            class="white--text align-end"
            gradient="to bottom, rgba(2,40,68,.83), rgba(9,65,107,.3)"
            max-height="280px">
            <v-card-text class="align-center text-center">
              <div class="mb-4">
                <v-btn fab :color="action.color" elevation="0" x-large dark>
                  <v-icon x-large>{{action.icon}}</v-icon>
                </v-btn>
              </div>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1 title text-uppercase white--text font-weight-bold">{{action.title}}</v-list-item-title>
                  <v-list-item-subtitle class="white--text">{{action.message}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-img>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense no-gutters>

      <v-col cols="4" v-if="showMainPermiss('empresa.dashboard.Bienes.empleado')">
        <CardIndicatorDataField :itemAction="IndicadorEmpleadoBaja" :on-success="sendInventarios"/>
      </v-col>

      <v-col cols="4" v-if="showMainPermiss('empresa.dashboard.Bienes.departamento')">
        <CardIndicatorDataField :itemAction="IndicadorDepartamento" :on-success="sendInventarios"/>
      </v-col>

      <v-col cols="4" v-if="showMainPermiss('empresa.dashboard.Bienes.empleados-sin-bienes')">
        <CardIndicatorDataField :itemAction="IndicadorEmpleadoSinBienes" :on-success="sendInventarios"/>
      </v-col>
      <v-col cols="4" class="actors">
        <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import CardIndicatorDataField from '@/components/fields/specific/CardIndicatorDataField'
import router from '@/router'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    actionsEisy: [
      {
        id: 'ma.list',
        icon: 'mdi-animation',
        color: 'lime darken-3',
        action: 'SeguimientosView',
        title: 'Seguimiento',
        message: 'Seguimiento de facturas',
        hidden: 'hiddenItem'
      },
      {
        id: 'inv.list',
        icon: 'mdi-receipt',
        color: 'blue darken-3',
        action: 'FacturasView',
        title: 'Facturas',
        message: 'Administración de facturas',
        hidden: 'hiddenItem'
      },
      {
        id: 'prov.list',
        icon: 'mdi-hand-coin',
        color: 'amber darken-2',
        action: 'ProveedoresView',
        title: 'Proveedores',
        message: 'Administracion de proveedores',
        hidden: 'hiddenItem'
      },
      {
        id: 'cont.list',
        icon: 'mdi-file-sign',
        color: 'amber darken-2',
        action: 'ContratosView',
        title: 'Contratos',
        message: 'Administracion de proveedores',
        hidden: 'hiddenItem'
      }
    ],
    IndicadorEmpleadoBaja: { color: 'light-green darken-2', height: 180, url: 'dashboard/indicadores/empleado', action: 'InventarioEmpleadoView' },
    IndicadorDepartamento: { color: '#F57C00', height: 180, url: 'dashboard/indicadores/departamento-desfasados', action: 'InventarioDepartamentoView' },
    IndicadorEmpleadoSinBienes: { color: 'light-blue darken-2', height: 180, url: 'dashboard/indicadores/empleados-sin-bienes', action: 'EmpledosSinInventarioView' },

    table: {
      modelMain: [],
      showSelect: false,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Tipo de solicitud', value: 'tipo_solicitud', class: 'black--text' },
          { text: 'Inventariable', value: 'inventariable', class: 'black--text' },
          { text: 'Controlable', value: 'controlable', class: 'black--text' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain,
    CardIndicatorDataField
  },
  mounted () {
    this.ShowPermisosMenu({ permisos: JSON.parse(localStorage.getItem('permisos')), MenuMain: this.actionsEisy })
    this.refreshData({})
  },
  methods: {
    ...mapActions(['GETObjectService']),
    ...mapMutations([]),
    SuccessTableAction (item) { this[item.action](item) },
    refreshData (item) {
      this.table.header.loading = true
      this.GETObjectService({ url: '/dashboard/indicadores/tabla-general' })
    },
    ReadOnlyPermiso (permisos, permiso) {
      if (permisos.descripcion.special === 'all-access') return true
      const acceso = permisos.permisos.find(item => item.slug === permiso)
      return !!acceso // Ensure the result is boolean
    },
    showMainPermiss (permiso) {
      return this.ReadOnlyPermiso(JSON.parse(localStorage.getItem('permisos')), permiso)
    },
    sendInventarios (vista) {
      router.push({ name: vista })
    }

  },
  computed: {
    ...mapGetters(['get_object'])
  },
  watch: {
    get_object (data) {
      this.table.header.loading = false
      if (data && data.message) return
      this.table.body.data = data.tableSolicitudes
    }
  }
}
</script>

<style>
.actors {
    margin-top: 20px;
  }
</style>
